import React, {useEffect, useRef} from 'react';
import * as TypeEvaluation from '../TypeEvaluation';
import * as NamingFns from '../utilities/NamingFns';
import TableGrid from '../StockItems/TableGrid';
import DoGuide from '../Tabs/DoGuide';

function App(props) {

  var getOrig = props.getOrig;
  var formulaPieceInGeneral = props.formulaPieceInGeneral;
  var objPath = props.objPath;
  var currentList = props.currentList;
  var errorString = props.errorString;
  var organicChanges = props.organicChanges;
  var stylePath = props.stylePath;
  var leftColRefs = props.leftColRefs;
  var setLeftColRefs = props.setLeftColRefs;
  var addToExtraScreen = props.addToExtraScreen;

  const ref1 = useRef();

  var pathHere = objPath.concat(['s', 'rFormula']);
  var pathText = pathHere.join(' ');

  useEffect(()=>{
    leftColRefs[pathText] = ref1;
    setLeftColRefs({...leftColRefs});

    if (errorString === pathText){
      if (ref1 && ref1.current){
        ref1.current.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  var origMultiple = getOrig('rFormula');    
  var but = [{t:'Once',i:false, ic:'arcticons:number-1',h:'This element is shown once'}, {t:'Dynamic',i:true, ic:'fluent:braces-variable-20-filled', h:'This element is shown a variable number of times, based on the formula specified'}];
  var isMultiple = false;
  var adjustFormulaPiece;
  function doFormula(e){
      formulaPieceInGeneral('rFormula', 'Multiple Row Formula', {t:'ListType',c:{t:'any',v:0}})();   
  }
  if (origMultiple && origMultiple.t === 'formula'){
    isMultiple = true;

    var upwardInfo = []; 
    var objectType = TypeEvaluation.evalType(origMultiple.o, pathHere, currentList, upwardInfo);
    var vv = NamingFns.getTextOfAPath(currentList, pathHere, objectType);

    var rFormulaStyle = {textDecoration:'underline', cursor:'pointer'};
    if (errorString.indexOf(objPath.concat(['s', 'rFormula']).join(' ')) === 0){
      rFormulaStyle.color = 'red';
    }
    // var formulaP5 = formulaPiece(anItem, 'Dynamic Line');
    adjustFormulaPiece = <center><span onClick={doFormula} style={rFormulaStyle}>Formula : {vv.t}</span></center>
    // adjustFormulaPiece = form
  }
//
  function setMultiple(input){
      if (input.i){
        doFormula();       
      }else{
        var changes3 = [{t:'w', w:stylePath.concat(['rFormula', 't']), n:'notFormula'}];
        organicChanges(changes3);
      }
  }

// 
  return (<td ref={ref1}>
      <DoGuide addToExtraScreen={addToExtraScreen} set={{t:'rFormula'}} />
    Number of Instances<TableGrid options={but} currentAnswer={isMultiple} onClick={setMultiple} />{adjustFormulaPiece}</td>)
//
  }
//
export default App;
